import React from 'react';
import { Button, Dropdown } from 'antd';
import type { MenuProps } from 'antd';
import {
  DownloadOutlined,
  SendOutlined,
  UserAddOutlined,
  TrophyOutlined,
} from '@ant-design/icons';
import { useAppDispatch, useAppSelector } from 'store';
import { exportStats, selectLoadingFor } from 'store/slices/stats.slice';

type ExportType = 'push' | 'users' | 'conversions';

interface ExportButtonProps {
  appId: number;
  period: '7d' | '30d' | '90d';
}

const PERIOD_LABELS: Record<string, string> = {
  '7d': '7 дней',
  '30d': '30 дней',
  '90d': '90 дней',
};

const EXPORT_TYPES: { key: ExportType; label: string; icon: React.ReactNode }[] = [
  { key: 'push', label: 'Push-статистика', icon: <SendOutlined /> },
  { key: 'users', label: 'Пользователи', icon: <UserAddOutlined /> },
  { key: 'conversions', label: 'Конверсии', icon: <TrophyOutlined /> },
];

export const ExportButton: React.FC<ExportButtonProps> = ({ appId, period }) => {
  const dispatch = useAppDispatch();
  const loading = useAppSelector(selectLoadingFor('export'));

  const handleClick: MenuProps['onClick'] = ({ key }) => {
    dispatch(exportStats({ app_id: appId, type: key as ExportType, period }));
  };

  const items: MenuProps['items'] = [
    {
      key: 'period',
      type: 'group',
      label: `Период: ${PERIOD_LABELS[period] ?? period}`,
      children: EXPORT_TYPES.map((type) => ({
        key: type.key,
        icon: type.icon,
        label: type.label,
      })),
    },
  ];

  return (
    <Dropdown menu={{ items, onClick: handleClick }} trigger={['click']} placement="bottomRight">
      <Button icon={<DownloadOutlined />} loading={loading} size="small" block>
        Экспорт CSV
      </Button>
    </Dropdown>
  );
};